var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _c("package", {
          attrs: { onhistory: _vm.onhistory },
          on: {
            onhistory: function ($event) {
              return _vm.$emit("onhistory")
            },
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "mb-3" },
      [
        _c("invoice", {
          attrs: { onhistory: _vm.onhistory },
          on: {
            onhistory: function ($event) {
              return _vm.$emit("onhistory")
            },
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }